import React from 'react';

export default function ServiceIconBox({
  Icon,
  variant,
}: {
  Icon: React.ComponentType<{ className?: string }>;
  variant?: 'completed';
}) {
  return (
    <div
      className={`dash-service-icon${variant === 'completed' ? ' dash-service-icon--completed' : ''} flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-md`}
    >
      <Icon className="h-[22px] w-[22px]" />
    </div>
  );
}
